import React from 'react'
import PageHeader from '../../components/PageHeader'
import InventoryLpnTable from './InventoryLpnTable'


const InventoryLpn = () => {
  return (
    <div className="dashboard-container">
      <PageHeader title="Inventory LPN"  hideCalendar/>
      <InventoryLpnTable />
    </div>
  )
}

export default InventoryLpn